<template>
    <div class="com-partm6 flex justify-center">
        <div
            v-for="(pool, i) in config"
            :key="'config' + i"
            class="pool-item">
            <div class="pool-title flex justify-center align-center">{{ pool.name }}</div>
            <div class="pool-top flex justify-center align-center mt-20">
                <div class="top-item top-l flex flex-direction">
                    <img class="top-img" :src="require('@/assets/images/computility/monitor-icon2.png')" alt="">
                    <div class="top-label">实时温度</div>
                    <div class="top-vale">{{ pool.temp }}°C</div>
                </div>
                <div class="top-item top-r flex flex-direction">
                    <img class="top-img" :src="require('@/assets/images/computility/monitor-icon3.png')" alt="">
                    <div class="top-label">实时湿度</div>
                    <div class="top-vale">{{ pool.humi }}%</div>
                </div>
            </div>
            <div class="pool-content flex flex-wrap">
                <div
                    v-for="(rittal, x) in pool.data"
                    :key="'rittal' + x"
                    class="rittal-item flex justify-center align-center mt-50">
                    <div>
                        <div
                            class="server-box flex align-center"
                            v-for="(server, y) in rittal"
                            :key="'rittal' + y"
                            :style="{'bottom': `${(60 * y) + 10}px`}">
                            <div class="server-name">{{ server && server[0].host_server_id }}</div>
                            <div class="server-state"
                                :class="serverState(server)"></div>
                            <div
                                v-for="(item, z) in server"
                                :key="'server' + z"
                                class="server-item">
                                <div
                                    class="server-load"
                                    :class="setServerUser(item)">
                                    <div :style="{'height': `${100 - parseFloat(item.xcfz, 10)}%`}"></div>
                                </div>
                                <div v-if="item.gpu_status == '关机'" class="server-tem close"></div>
                                <div v-else class="server-tem"
                                    :class="setServerTemp(item)"></div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import MyTitle from './myTitle1.vue'
import myEchart from "./charts/echarts"
import { dataInterface } from "@/api/dataInterfaceApi"
export default {
    components: {
        MyTitle,
        myEchart
    },
    data() {
        return {
			config: [],
            timer: null
        }
    },
	mounted() {
        // 获取冷池数据
        this.getPoolData()
        // this.timer = setInterval(() =>{
        //     // this.getPoolData()
        // }, 5 * 1000)
    },
	methods: {
        // 服务器状态
        serverState(server){
            let { host_status } = server && server[0] || {}
            return host_status == 'START' ? 'open' : (host_status == 'STOP' ? 'close' : 'error')
        },
        // 显卡使用负载
        setServerUser(item) {
            let xcfz = parseFloat(item.xcfz)
            if(xcfz && xcfz < 50) {
                return 'green'
            }
            else if(xcfz >= 50 && xcfz < 80) {
                return 'yellow'
            }
            else if(xcfz >= 80) {
                return 'red'
            }
        },
        // 显卡温度
        setServerTemp(item){
            let gpuwd = parseFloat(item.gpuwd)
            if(gpuwd && gpuwd < 70) {
                return 'green'
            }
            else if(gpuwd >= 70 && gpuwd < 90) {
                return 'yellow'
            }
            else if(gpuwd >= 90) {
                return 'red'
            }
        },
        // 获取冷池数据
        getPoolData() {
            let _this = this
            let params = {
                enCode: 'computingpower-mid-lclb'
            }
            dataInterface.dataFaceApi(params).then(res => {
                // console.log('sdfsdfsf', res)
                if(res && res.length) {
                    _this.config = _this.groupBy(res, function (item) {
		              return [item.cold_pond_id]
		            }).map( item => {
                        let poolObj = item[0] || {}
                        let dataliset = _this.groupBy(item, function (pool) {
                                return [pool.cabinet_id]
                            }).map( item => {
                                let aaa =  _this.groupBy(item, function (pool) {
                                    return [pool.host_server_id]
                                }).sort((a, b) => {
                                    return b[0].host_server_id.slice(7,8) - a[0].host_server_id.slice(7,8)
                                })
                                return aaa
                            })
                            .sort((a, b) => {
                                return a[0][0].cabinet_id.slice(4,6) - b[0][0].cabinet_id.slice(4,6)
                            })
                            // debugger
                        return {
                            id: `${poolObj.cold_pond_id.replace('#', '')}`,
                            name: `冷池${poolObj.cold_pond_id}`,
                            temp: poolObj.cold_pool_temperature,
                            humi: poolObj.cold_pool_humidity,
                            data: dataliset
                        }
                    }).sort((a, b) => {
                        return a.id - b.id
                    })
                    console.log('冷池数量`````', this.config)
                }
            })
        },
        // 数组遍历
        groupBy (array, fun) {
            const groups = {};
            array.forEach(item => {
                const group = JSON.stringify(fun(item))
                groups[group] = groups[group] || []
                groups[group].push(item)
            })
            return Object.keys(groups).map((group) => {
                return groups[group]
            })
        }
    },
	destroyed () {
	    console.log('destroyed')
	    clearInterval( this.timer )
	}
}
</script>

<style lang="scss" scoped>
@import './comm.scss';
.com-partm6 {
    width: 100%;
    height: 1167px;
    .pool-item {
        width: 820px;
        height: 1167px;
        margin: 0 80px;
        background: url(~@/assets/images/computility/monitor-icon1.png) no-repeat;
        background-size: 100% 100%;
        .pool-title {
            height: 60px;
            font-size: $FontSize40;
            @include ffamily-PMZD;
        }
        .pool-top {
            // padding-left: 100px;
            position: relative;
            .top-item {
                position: absolute;
                top: -60px;
                width: 220px;
                padding-left: 70px;
                &.top-l {
                    left: 50px;
                }
                &.top-r {
                    right: 10px;
                }
                .top-img {
                    position: absolute;
                    width: 52px;
                    height: 52px;
                    top: 50%;
                    left: 0;
                    transform: translate(0, -50%);
                }
                .top-label {
                    font-size: $FontSize24;
                }
                .top-vale {
                    font-size: $FontSize40;
                    color: #FFD15C;
                    @include ffamily-DS;
                }
            }
        }
        .rittal-item {
            width: 33.33%;
            > div {
                width: 220px;
                height: 160px;
                background: url(~@/assets/images/computility/monitor-icon4.png) center bottom no-repeat;
                background-size: 100%;
                position: relative;
                .server-box {
                    padding: 12px 0 0 8px;
                    position: absolute;
                    width: 148px;
                    height: 58px;
                    left: 50%;
                    transform: translate(-50%, 0);
                    background: url(~@/assets/images/computility/monitor-icon5.png) center bottom no-repeat;
                    background-size: 100%;
                    .server-name {
                        position: absolute;
                        width: 100%;
                        top: -9px;
                        left: 0;
                        text-align: center;
                        font-size: $FontSize24;
                    }
                    .server-state {
                        position: absolute;
                        width: 100%;
                        text-align: center;
                        background-color: #979797;
                        width: 7px;
                        height: 13px;
                        border-radius: 5px;
                        right: 5px;
                        bottom: 10px;
                        &.open {
                            background-color: #5BCF41;
                            @include brightness;
                        }
                        &.error {
                            background-color: #E5750D;
                            @include brightness;
                        }
                        &.close {
                            background-color: #979797;
                        }
                    }
                    .server-item {
                        width: 10px;
                        height: 28px;
                        background-color: #32302F;
                        margin-right: 5px;
                        position: relative;
                        .server-load {
                            position: absolute;
                            width: 100%;
                            height: 20px;
                            background: url(~@/assets/images/computility/monitor-icon6.png) center bottom no-repeat;
                            background-size: 100% 100%;
                            &.green {
                                background: url(~@/assets/images/computility/monitor-icon7.png) center bottom no-repeat;
                                background-size: 100% 100%;
                            }
                            &.yellow {
                                background: url(~@/assets/images/computility/monitor-icon8.png) center bottom no-repeat;
                                background-size: 100% 100%;
                            }
                            &.red {
                                background: url(~@/assets/images/computility/monitor-icon9.png) center bottom no-repeat;
                                background-size: 100% 100%;
                            }
                            > div {
                                position: absolute;
                                width: 100%;
                                bottom: 0;
                                left: 0;
                                background-color: #32302F;
                            }
                        }
                        .server-tem {
                            position: absolute;
                            width: 100%;
                            height: 8px;
                            bottom: 0;
                            background: #232121;
                            &::after {
                                position: absolute;
                                content: '';
                                width: 4px;
                                height: 4px;
                                background-color: #979797;
                                border-radius: 50%;
                                top: 50%;
                                left: 50%;
                                transform: translate(-50%, -50%);
                            }&.green {
                                @include brightness;
                                &::after {
                                    background-color: #6DBF87;
                                }
                            }
                            &.yellow {
                                @include brightness;
                                &::after {
                                    background-color: #FFC806;
                                }
                            }
                            &.red {
                                @include brightness;
                                &::after {
                                    background-color: #FF0606;
                                }
                            }
                            &.close {
                                &::after {
                                    background-color: #979797;
                                }
                            }
                        }
                    }
                }
            }
        }
    }
}
</style>